import { queryOptions } from '@tanstack/react-query';
import { getNodeExecutions } from '../api/getNodeExecutions';

const nodeExecutions = {
  list: (flowId: string, nodeId: string) =>
    queryOptions({
      queryKey: ['nodeExecutions', flowId, nodeId],
      queryFn: () => getNodeExecutions(flowId, nodeId),
      enabled: !!flowId && !!nodeId,
    }),
};

export { nodeExecutions };
